.inputFields {
  display: flex;
  flex-direction: column;
  gap: 1.5em;

  .row {
    display: flex;
    gap: 1em;
  }

  &:first-child {
    margin-top: 1.5em;
  }
}
